/**
 * Build PUT /customer/consent/preferences body (P3.1-02).
 */
import { readAnonymousKey } from '../../shared/analytics/analyticsAnonymousStorage.js';

export interface ConsentPreferencesInput {
  readonly analytics: boolean;
  readonly marketing: boolean;
}

export interface ConsentPreferencesPayload extends ConsentPreferencesInput {
  readonly anonymousKey?: string;
  readonly propagateToAllMemberships?: boolean;
}

export function buildConsentPreferencesPayload(
  tenantCode: string,
  input: ConsentPreferencesInput,
  options?: {
    readonly storage?: Parameters<typeof readAnonymousKey>[1];
    readonly anonymousKey?: string | null;
    readonly propagateToAllMemberships?: boolean;
  },
): ConsentPreferencesPayload {
  const base = ((): ConsentPreferencesPayload => {
    if (input.analytics) {
      return { analytics: input.analytics, marketing: input.marketing };
    }
    const key =
      options?.anonymousKey !== undefined
        ? options.anonymousKey
        : readAnonymousKey(tenantCode, options?.storage);
    if (key === null) {
      return { analytics: input.analytics, marketing: input.marketing };
    }
    return {
      analytics: input.analytics,
      marketing: input.marketing,
      anonymousKey: key,
    };
  })();

  if (options?.propagateToAllMemberships === true) {
    return {
      ...base,
      propagateToAllMemberships: true,
    };
  }
  return base;
}
